<template>
  <ReadableRowContent
    :flush="true"
    data-id="table-row-email"
    :text="body"
    :from="email.from || ''"
    icon="inbox"
    :icon-label="email.inboxId"
    :read="email.read"
    :subject="email.subject || ''"
    :to="to"
  />
</template>
<script lang="ts" setup>
import type { EmailProjection } from '@mailslurp/admin-sdk';
import { computed } from 'vue';
import ReadableRowContent from './ReadableRowContent.vue';

const props = defineProps<{ email: EmailProjection }>();
const body = computed(() => {
  return props.email.textExcerpt ?? props.email.bodyExcerpt ?? '';
});
const to = computed(() => `/emails/${props.email.id}`);
</script>
